var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1578 21.1875C28.0809 21.1266 22.5 17.1038 20.9681 17.3925C20.2369 17.5219 19.8188 18.0206 18.9797 19.0191C18.8447 19.1803 18.5203 19.5666 18.2681 19.8413C17.7379 19.6683 17.2206 19.4578 16.7203 19.2113C14.138 17.9541 12.0516 15.8676 10.7944 13.2853C10.5477 12.7851 10.3371 12.2678 10.1644 11.7375C10.44 11.4844 10.8263 11.16 10.9913 11.0212C11.985 10.1869 12.4847 9.76875 12.6141 9.03563C12.8794 7.51687 8.85938 1.8975 8.81719 1.84688C8.6348 1.58632 8.39676 1.36956 8.12032 1.21228C7.84387 1.05501 7.53592 0.961151 7.21875 0.9375C5.58938 0.9375 0.9375 6.97219 0.9375 7.98844C0.9375 8.0475 1.02281 14.0513 8.42625 21.5822C15.9497 28.9772 21.9525 29.0625 22.0116 29.0625C23.0288 29.0625 29.0625 24.4106 29.0625 22.7812C29.0391 22.4652 28.9458 22.1583 28.7894 21.8827C28.6329 21.607 28.4172 21.3696 28.1578 21.1875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.ca81e0b63bc6a01585d118f017bdde37.svg";
export { ForwardRef as ReactComponent };